<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
      <div class="loading" v-if="isLoading">
        <img class="rotate" src="/reclamaciones/img/refresh.svg" width="180px" height="180px" />
      </div>
      <simple-wizard>
        <template slot="header">
          <h3
            class="title"
          >¿Tienes alguna duda o sugerencia con nuestros productos? ¿Has tenido algún problema?</h3>
          <h5 class="category">Ayúdanos a mejorar, infórmanos de tu problema.</h5>
          <h5 class="category">Cuéntanos que te ha pasado y lo solucionaremos.</h5>
          <loading
            :active.sync="isLoading"
            :is-full-page="fullPage"
            :background-color="bgColor"
            :color="color"
            :height="height"
            :loader="loader"
            :opacity="1"
          ></loading>
        </template>

        <wizard-tab :before-change="() => validateStep('step_user')">
          <template slot="label">Indentificación</template>
          <step-user ref="step_user" @on-validated="onStepValidated" v-bind:user="issue.user" />
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step_product')">
          <template slot="label">Producto</template>
          <step-product
            ref="step_product"
            @on-validated="onStepValidated"
            v-bind:product="issue.product"
          />
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step_photo')">
          <template slot="label">Problema</template>
          <step-photo
            ref="step_photo"
            @on-validated="onStepValidated"
            v-bind:product="issue.product"
          />
        </wizard-tab>
        <wizard-tab :before-change="() => validateStep('step_summary')">
          <template slot="label">Final</template>
          <step-summary ref="step_summary" @on-validated="wizardComplete" v-bind:issue="issue" />
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>

<script>
import StepUser from "./StepUser";
import StepProduct from "./StepProduct";
import StepSummary from "./StepSummary";
import StepPhoto from "./StepPhoto";
import { SimpleWizard, WizardTab } from "@/components";
import swal from "sweetalert2";
import { apiServer, staticServer, florette_web } from "@/globalVars.js";
import parse from "date-fns/parse";
import format from "date-fns/format";
import { es } from "date-fns/locale";

// Import component
import Loading from "vue-loading-overlay";

export default {
  name: "consumer-new-issue",
  components: {
    StepUser,
    StepProduct,
    //StepLocation,
    StepSummary,
    StepPhoto,
    SimpleWizard,
    WizardTab,
    Loading
  },
  data: () => ({
    isLoading: false,
    active: "first",
    first: false,
    color: "#43a047",
    loader: "dots",
    fullPage: true,
    height: 48,
    bgColor: "#ffffff",
    contract: null,
    product_step: false,
    third: false,
    fourth: false,
    photo: false,
    issue: {
      user: {
        firstName: null,
        phone: null,
        email: null,
        address: null
      },
      location: {},
      product: {
        lote: null,
        selected: false,
        provincia: null,
        municipio: null,
        caedena: null,
        comercio: null,
        problemType: null,
        problemDesc: null,
        observaciones: null,
        category: null,
        type: null,
        images: [],
        files: [],
        caducidad: null
      }
    }
  }),
  methods: {
    setDone(id, index) {
      this[id] = true;

      if (index) {
        this.active = index;
      }
    },
    setError() {},
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    wizardComplete() {
      this.$recaptcha("send_reclamacion").then(token => {
        this.sendReclamacion(token);
      });
    },
    sendImage(id) {
      this.$recaptcha("send_reclamacion").then(token => {
        let endpoint_api =
          apiServer + "/reclamacion/consumidor/" + id + "/upload";

        let formData = new FormData();
        for (let index = 0; index < this.issue.product.files.length; index++) {
          formData.append("file", this.issue.product.files[index]);
        }
        formData.append("token", token);

        fetch(endpoint_api, {
          method: "POST",
          body: formData
        })
          .then(response => {
            this.isLoading = false;
            swal({
              title: "¡Reclamacion enviada!",
              text: "¡Gracias por tu ayuda!",
              type: "success",
              confirmButtonClass: "md-button md-success",
              buttonsStyling: false
            }).then(result => {
              this.$router.push("/dashboard");
            });
          })
          .catch(error => {
            this.isLoading = false;
            swal({
              title: "¡Se ha producido un error!",
              type: "error",
              confirmButtonClass: "md-button md-error",
              buttonsStyling: false
            });
          });
      });
    },
    sendReclamacion(token) {
      window.scrollTo(0, 400);
      this.contract = {
        consumidor: {
          nombre: this.issue.user.firstName,
          email: this.issue.user.email,
          telefono: this.issue.user.phone,
          direccion: this.issue.user.address
        },
        incidencia: {
          tipo: this.issue.product.problemType,
          observaciones: this.issue.product.problemDesc
        },
        producto: {
          lote: this.issue.product.lote,
          centroId: null,
          productoId: null,
          fechaCaducidad: null
        },
        token: token
      };

      if (this.issue.product.type != null) {
        this.contract.producto.productoId = this.issue.product.type._id;
      }
      if (this.issue.product.comercio != null) {
        this.contract.producto.centroId = this.issue.product.comercio._id;
      }
      if (this.issue.product.caducidad != null) {
        this.contract.producto.caducidad = format(
          this.issue.product.caducidad,
          "yyyy-MM-dd",
          {
            locale: es
          }
        );
      }

      fetch(apiServer + "/reclamacion/consumidor/", {
        method: "POST",
        headers: new Headers(),
        body: JSON.stringify(this.contract)
      })
        .then(res => {
          if (!res.ok) {
            res.json().then(data => {
              this.isLoading = false;
              swal({
                title: "¡Se ha producido un error!",
                type: "error",
                text: data.error,
                confirmButtonClass: "md-button md-error",
                buttonsStyling: false
              });
            });
            return;
          }
          res.json().then(data => {
            let self = this;
            this.isLoading = true;
            if (this.issue.product.files.length > 0) {
              setTimeout(function() {
                self.sendImage(data._id);
              }, 1000);
            } else {
              this.isLoading = false;
              swal({
                title: "¡Reclamacion enviada!",
                text: "¡Gracias por tu ayuda!",
                type: "success",
                confirmButtonClass: "md-button md-success",
                buttonsStyling: false
              }).then(result => {
                this.$router.push("/dashboard");
              });
            }
          });
        })
        .catch(error => {
          this.isLoading = false;
          swal({
            title: "¡Se ha producido un error!",
            type: "error",
            confirmButtonClass: "md-button md-error",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>
<style scoped>
.rotate {
  animation: rotation 4s infinite linear;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.loading {
  width: 100%;
  background-color: white;
  opacity: 0.75;
  position: absolute;
  height: 100%;
  top: 0px;
  z-index: 3000;
  left: 0;
  display: flex;
  justify-content: center;
}
</style>
